"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pietrarubbia": {
    "75ffdf46": [{
      "hkey": "079e1026",
      "slug": "pietrarubbia",
      "name": "Pietrarubbia",
      "primary": true,
      "skipSearch": false
    }],
    "ca-baldiserra": [{
      "hkey": "079e1026",
      "slug": "pietrarubbia",
      "name": "Pietrarubbia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea94d543": [{
      "hkey": "20c13e8d",
      "slug": "villa-del-piano-ca-bartolino",
      "name": "Villa del Piano-Ca' Bartolino",
      "primary": true,
      "skipSearch": false
    }],
    "ca-bartolino": [{
      "hkey": "20c13e8d",
      "slug": "villa-del-piano-ca-bartolino",
      "name": "Villa del Piano-Ca' Bartolino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pietrarubbia"
    }],
    "ab241562": [{
      "hkey": "079e1026",
      "slug": "pietrarubbia",
      "name": "Pietrarubbia",
      "primary": true,
      "skipSearch": false
    }],
    "ca-ivano": [{
      "hkey": "079e1026",
      "slug": "pietrarubbia",
      "name": "Pietrarubbia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8feab58a": [{
      "hkey": "fe3cdc60",
      "slug": "lago-del-conte-ca-mafuccio",
      "name": "Lago del Conte-Ca' Mafuccio",
      "primary": true,
      "skipSearch": false
    }],
    "ca-mafuccio": [{
      "hkey": "fe3cdc60",
      "slug": "lago-del-conte-ca-mafuccio",
      "name": "Lago del Conte-Ca' Mafuccio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pietrarubbia"
    }],
    "3fc2147e": [{
      "hkey": "079e1026",
      "slug": "pietrarubbia",
      "name": "Pietrarubbia",
      "primary": true,
      "skipSearch": false
    }],
    "ca-mancino": [{
      "hkey": "079e1026",
      "slug": "pietrarubbia",
      "name": "Pietrarubbia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0c766e5c": [{
      "hkey": "079e1026",
      "slug": "pietrarubbia",
      "name": "Pietrarubbia",
      "primary": true,
      "skipSearch": false
    }],
    "fonte-del-bacio": [{
      "hkey": "079e1026",
      "slug": "pietrarubbia",
      "name": "Pietrarubbia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "85012229": [{
      "hkey": "fe3cdc60",
      "slug": "lago-del-conte-ca-mafuccio",
      "name": "Lago del Conte-Ca' Mafuccio",
      "primary": true,
      "skipSearch": false
    }],
    "lago-del-conte": [{
      "hkey": "fe3cdc60",
      "slug": "lago-del-conte-ca-mafuccio",
      "name": "Lago del Conte-Ca' Mafuccio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cd3629e7": [{
      "hkey": "079e1026",
      "slug": "pietrarubbia",
      "name": "Pietrarubbia",
      "primary": true,
      "skipSearch": false
    }],
    "pietrarubbia-castello": [{
      "hkey": "079e1026",
      "slug": "pietrarubbia",
      "name": "Pietrarubbia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2b697c98": [{
      "hkey": "079e1026",
      "slug": "pietrarubbia",
      "name": "Pietrarubbia",
      "primary": true,
      "skipSearch": false
    }],
    "sant-arduino": [{
      "hkey": "079e1026",
      "slug": "pietrarubbia",
      "name": "Pietrarubbia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "48e1b328": [{
      "hkey": "20c13e8d",
      "slug": "villa-del-piano-ca-bartolino",
      "name": "Villa del Piano-Ca' Bartolino",
      "primary": true,
      "skipSearch": false
    }],
    "villa-del-piano": [{
      "hkey": "20c13e8d",
      "slug": "villa-del-piano-ca-bartolino",
      "name": "Villa del Piano-Ca' Bartolino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;